import type { RouteObject } from 'react-router';

import { ProductDetail } from '../pages/ProductDetail/ProductDetail';
import { ProductDetailsProvider } from '../providers';

export const productDetailRoute = (pdpRouteId?: string): RouteObject => ({
  element: (
    <ProductDetailsProvider>
      <ProductDetail />
    </ProductDetailsProvider>
  ),
  id: pdpRouteId,
  path: `products/:productId`,
});
